import expressions from './expressions.ts';

const langCode = 'zht';
export default Object.fromEntries(
  Object.entries(expressions).map<[string, string]>(([key, values]) => [
    key,
    values[langCode] ?? values['en'],
  ])
);
